import { render, staticRenderFns } from "./userAuthorisation.vue?vue&type=template&id=3b5f3bbc&"
import script from "./userAuthorisation.vue?vue&type=script&lang=js&"
export * from "./userAuthorisation.vue?vue&type=script&lang=js&"
import style0 from "./userAuthorisation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports